import { TutorialAffiliationProps } from "./types";
import { Button } from "@/components/ui/button";
import { Wallet } from "lucide-react";

export function TutorialAffiliation({ onClick }: TutorialAffiliationProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border bg-cede-bg-select border-cede-border-container/60 px-4 py-3 text-sm text-cede-text-primary md:flex-row md:justify-between">
      <p className="text-center md:text-left">Don't have an account yet?</p>

      <Button
        variant="secondary"
        size="small"
        onClick={onClick ?? (() => undefined)}
        className="inline-flex items-center gap-2"
      >
        <Wallet className="h-4 w-4" />
        Create account
      </Button>
    </div>
  );
}
